<script setup>
import ModalBox from './ModalBox.vue'
import MultiviewTile from '@/components/Multiview/MultiviewTile.vue'
import { useLegacyModalBridge } from '@/composables/useLegacyModalBridge'

const props = defineProps({
	modalId: {
		type: String,
		default: 'modal-confirm2',
	},
	modalSize: {
		type: String,
		default: 'sm',
		validator(v) {
			return ['xl', 'lg', 'md', 'sm'].some((size) => size === v)
		},
	},
	closeoutsideClick: {
		type: Boolean,
		default: false,
	},
	layout: {
		type: Number,
		required: true,
	},
})

const emit = defineEmits(['on-layout-resize', 'modal-hidden'])

const { isVisible, hide } = useLegacyModalBridge(() => props.modalId, {
	onHidden: () => emit('modal-hidden'),
})

const tileSelected = (newLayout) => {
	if (props.layout === newLayout) {
		hide()
		return
	}
	emit('on-layout-resize', newLayout)
	hide()
}
</script>

<template>
	<ModalBox
		v-model="isVisible"
		:size="modalSize"
		hide-close
		header-class="!hidden"
		mobile-placement="bottom"
		wrapper-classes="lg:h-auto lg:max-h-none body-margin-bottom px-4 pb-6"
		:close-on-backdrop="!closeoutsideClick"
	>
		<slot />
		<div class="flex items-center justify-between gap-4 px-2 pt-4">
			<MultiviewTile
				v-for="(item, index) in [2, 4, 6]"
				:key="index"
				:tiles="item"
				:selected="item === layout"
				fontClass="text-dark-7 text-x-ss"
				@tile-selected="tileSelected"
			/>
		</div>
	</ModalBox>
</template>

<style>
.body-margin-bottom {
	margin-bottom: 0;
}
</style>
